import { ROLE_ALL, ROLE_GET, ROLE_DEL, ROLE_PUT, ROLE_POST, ROLE_LOADING, ROLE_ERROR } from '../../actions/types';

const initialState = {
  role: null,
  isLoading: true,
  isCompleted: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ROLE_ALL:
      return { ...action.payload, isLoading: false, isCompleted: true };
    case ROLE_GET:
      return { ...action.payload, isLoading: false, isCompleted: true };
    case ROLE_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case ROLE_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) => ((r._id || r.id) === payloadId ? { ...r, ...action.payload } : r))
          : state.rows,
      };
    }
    case ROLE_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows ? state.rows.filter((r) => (r._id || r.id) !== delId) : state.rows,
      };
    }
    case ROLE_LOADING:
      return { ...state, isLoading: true };
    case ROLE_ERROR:
      return { ...state, isLoading: false, isCompleted: false, ...action.payload };
    default:
      return state;
  }
}
